var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnNavMenu = function SvgBtnNavMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5v5.47h5.47V1.5H1.5ZM1 0a1 1 0 0 0-1 1v6.47a1 1 0 0 0 1 1h6.47a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1ZM1.5 11.03v5.47h5.47v-5.47H1.5ZM1 9.53a1 1 0 0 0-1 1V17a1 1 0 0 0 1 1h6.47a1 1 0 0 0 1-1v-6.47a1 1 0 0 0-1-1H1ZM11.03 1.5v5.47h5.47V1.5h-5.47Zm-.5-1.5a1 1 0 0 0-1 1v6.47a1 1 0 0 0 1 1H17a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-6.47ZM11.03 11.03v5.47h5.47v-5.47h-5.47Zm-.5-1.5a1 1 0 0 0-1 1V17a1 1 0 0 0 1 1H17a1 1 0 0 0 1-1v-6.47a1 1 0 0 0-1-1h-6.47Z",
    fill: "#242526"
  })));
};
export default SvgBtnNavMenu;